import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface LanguagePayload {
  name: string;
}

@Component({
  selector: 'app-add-language',
  standalone: false,
  templateUrl: './add-language.html',
  styleUrl: './add-language.scss',
})
export class AddLanguage implements OnInit {
  pageTitle = 'Add New Language';

  pageSubtitle =
    'Create and organize a new course language.';

  languageForm!: FormGroup;

  isSubmitted = false;
  isSaving = false;

  private saveAnotherAfterSubmit = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  get nameControl(): AbstractControl {
    return this.languageForm.get(
      'name'
    ) as AbstractControl;
  }

  submitLanguage(): void {
    this.saveLanguage(false);
  }

  saveAndAddAnother(): void {
    this.saveLanguage(true);
  }

  private initializeForm(): void {
    this.languageForm =
      this.formBuilder.group({
        name: [
          '',
          [
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern(
              /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/
            )
          ]
        ]
      });
  }

  private saveLanguage(
    saveAnother: boolean
  ): void {
    this.isSubmitted = true;
    this.saveAnotherAfterSubmit =
      saveAnother;

    if (
      this.languageForm.invalid ||
      this.isSaving
    ) {
      this.languageForm.markAllAsTouched();
      return;
    }

    const formValue =
      this.languageForm.getRawValue();

    const payload: LanguagePayload = {
      name: formValue.name.trim()
    };

    this.isSaving = true;

    console.log(
      'Language payload:',
      payload
    );

    /*
    Replace the timeout with your API:

    this.languageService
      .createLanguage(payload)
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: () => {
          this.handleSaveSuccess();
        },
        error: (error) => {
          console.error(
            'Language creation failed:',
            error
          );
        }
      });
    */

    setTimeout(() => {
      this.isSaving = false;
      this.handleSaveSuccess();
    }, 800);
  }

  private handleSaveSuccess(): void {
    this.isSubmitted = false;

    if (this.saveAnotherAfterSubmit) {
      this.resetForm();
      return;
    }

    this.router.navigate([
      '/admin/course-reference/languages'
    ]);
  }

  private resetForm(): void {
    this.languageForm.reset({
      name: ''
    });

    this.saveAnotherAfterSubmit = false;
  }
    cancel(): void {
    window.history.back();
  }
}
